import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { CfcResolver } from '@services/apis/gestao/resolvers/cfc.resolver';
import { CfcAgendamentoResolver } from '@services/apis/agendamento/resolvers/cfc-agendamento.resolver';
import { CursoAgendamentoResolver } from '@services/apis/agendamento/resolvers/curso-agendamento.resolver';
import { ConteudoProgramaticoResolver } from '@core/services/apis/agendamento/resolvers/conteudo-programatico.resolver';
import { GrupoResolver } from '@services/apis/gestao/resolvers/grupo.resolver';
import { InstrutorAgendamentoResolver } from '@services/apis/agendamento/resolvers/instrutor-agendamento.resolver';
import { InstrutorResolver } from '@services/apis/gestao/resolvers/instrutor.resolver';
import { LocalResolver } from '@services/apis/gestao/resolvers/local.resolver';
import { MainComponent } from './main.component';
import { ProdutosResolver } from '@services/apis/financeiro/resolvers/produtos.resolver';
import { ROUTES_APLICATION } from '@constants/routes-aplication.constants';
import { RulesGuard } from '@core/guards/rules.guard';
import { ServicoAgendamentoResolver } from '@services/apis/agendamento/resolvers/servico-agendamento.resolver';
import { ServicosGestaoResolver } from '@services/apis/gestao/resolvers/servicos-gestao.resolver';
import { TipoExameResolver } from '@services/apis/gestao/resolvers/tipo-exame.resolver';
import { TipoDeLancamentoResolver } from '@services/apis/financeiro/resolvers/tipo-de-lancamento.resolver';
import { UnidadeDetranResolver } from '@services/apis/gestao/resolvers/unidade-detran.resolver';
import { VeiculoCfcResolver } from '@services/apis/gestao/resolvers/veiculo-cfc.resolver';
import { OrganizationResolver } from '@core/services/apis/agendamento-pratico/resolvers/organization.resolver';
import { InstructorResolver } from '@core/services/apis/agendamento-pratico/resolvers/instructor.resolver';
import { VehicleResolver } from '@core/services/apis/agendamento-pratico/resolvers/vehicle.resolver';
import { DelegaciaResolver } from '@core/services/apis/gestao/resolvers/delegacia.resolver';
import { RegiaoResolver } from '@core/services/apis/gestao/resolvers/regiao.resolver';
import { CategoriaResolver } from '@core/services/apis/gestao/resolvers/categoria.resolver';
import { LocalFotobiometriaResolver } from '@core/services/apis/gestao/resolvers/local-fotobiometria.resolver';
import { GrupoFinanceiroResolver } from '@core/services/apis/financeiro/resolvers/grupo-financeiro.resolver';
import { VeiculoResolver } from '@core/services/apis/gestao/resolvers/veiculo.resolver';
import { PessoaResolver } from '@core/services/apis/financeiro/resolvers/pessoa.resolver';
import { ContasCorrenteResolver } from '@core/services/apis/financeiro/resolvers/contas-corrente.resolver';
import { ProvedorResolver } from '@core/services/apis/gestao/resolvers/provedor.resolver';
import { AvailabilityTimeCollectionResolver } from '@core/services/apis/agendamento-pratico/resolvers/availability-time-collections.resolver';
import { GrupoLancamentoResolver } from '@core/services/apis/financeiro/resolvers/grupo-lancamento.resolver';
import { LocalAtendimentoDetranResolver } from '@core/services/apis/gestao/resolvers/local-atendimento-detran.resolver';

const mainRoutes: Routes = [
  {
    path: '',
    component: MainComponent,
    resolve: {
      //GESTÃO
      categoria: CategoriaResolver,
      cfcs: CfcResolver,
      delegacias: DelegaciaResolver,
      grupo: GrupoResolver,
      instrutores: InstrutorResolver,
      localFotoBiometria: LocalFotobiometriaResolver,
      locais: LocalResolver,
      locaisAtendimentoDetran: LocalAtendimentoDetranResolver,
      provedor: ProvedorResolver,
      regioes: RegiaoResolver,
      servicos: ServicosGestaoResolver,
      tipoExames: TipoExameResolver,
      unidadeDetran: UnidadeDetranResolver,
      veiculosCfc: VeiculoCfcResolver,
      veiculos: VeiculoResolver,

      //TEÓRICO
      cfcsAgendamento: CfcAgendamentoResolver,
      cursosAgendamento: CursoAgendamentoResolver,
      conteudoProgramatico: ConteudoProgramaticoResolver,
      instrutoresAgendamento: InstrutorAgendamentoResolver,
      servicosAgendamento: ServicoAgendamentoResolver,

      //FINANCEIRO
      contas: ContasCorrenteResolver,
      produtos: ProdutosResolver,
      pessoa: PessoaResolver,
      tipoLancamento: TipoDeLancamentoResolver,
      grupoFinanceiro: GrupoFinanceiroResolver,
      grupoLancamento: GrupoLancamentoResolver,

      //PRÁTICO
      instructor: InstructorResolver,
      organization: OrganizationResolver,
      vehicle: VehicleResolver,
      availabilityTimeCollection: AvailabilityTimeCollectionResolver
    },
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: ROUTES_APLICATION.audit.path,
        loadChildren: () => import('./modules/audit/audit.module').then(m => m.AuditModule),
        canActivate: [RulesGuard]
      },
      {
        path: ROUTES_APLICATION.exams.path,
        loadChildren: () => import('./modules/exams/exams.module').then(m => m.ExamsModule),
        canActivate: [RulesGuard]
      },
      {
        path: ROUTES_APLICATION.financial.path,
        loadChildren: () => import('./modules/financial/financial.module').then(m => m.FinancialModule),
        canActivate: [RulesGuard]
      },
      {
        path: ROUTES_APLICATION.home,
        loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
        canActivate: [RulesGuard]
      },
      {
        path: ROUTES_APLICATION.management.path,
        loadChildren: () => import('./modules/management/management.module').then(m => m.ManagementModule),
        canActivate: [RulesGuard]
      },
      {
        path: ROUTES_APLICATION.notifications.path,
        loadChildren: () => import('./modules/notifications/notifications.module').then(m => m.NotificationsModule),
        canActivate: [RulesGuard]
      },
      {
        path: ROUTES_APLICATION.practical_course.path,
        loadChildren: () => import('./modules/practical-course/practical-course.module').then(m => m.PracticalCourseModule),
        canActivate: [RulesGuard]
      },
      {
        path: ROUTES_APLICATION.register.path,
        loadChildren: () => import('./modules/register/register.module').then(m => m.RegisterModule),
        canActivate: [RulesGuard]
      },
      {
        path: ROUTES_APLICATION.theoretical_course.path,
        loadChildren: () => import('./modules/theoretical-course/theoretical-course.module').then(m => m.TheoreticalCourseModule),
        canActivate: [RulesGuard]
      },
      {
        path: ROUTES_APLICATION.user_settings.path,
        loadChildren: () => import('./modules/user-settings/user-settings.module').then(m => m.UserSettingsModule),
        canActivate: [RulesGuard]
      },
      {
        path: ROUTES_APLICATION.log.path,
        loadChildren: () => import('./modules/log/log.module').then(m => m.LogModule),
        canActivate: [RulesGuard]
      },
      {
        path: ROUTES_APLICATION.reports.path,
        loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule),
        canActivate: [RulesGuard]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(mainRoutes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
